import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import toast from "react-hot-toast";
import Layout4 from "../../Pages/DataLayouts/Layout4";
import TableDataGeneric from "../../Configurations/TableDataGeneric";
import { useNavigate } from "react-router-dom";


function CommonList({ mainUrl, mainKey, gridKey, heading, route, btnName, sortName, mode, copyFunction, viewFunction, infoFunction, dataFilter, filterDependency, additionalParams, add_action, edit_delete_action, copy_action, info_action, filterByReportingManagerEmployees, filterByReportingManagerInterns }) {

    const [mainData, setMainData] = useState([]);
    const { userData, reporting_manager_employees, reporting_manager_interns } = useAuthStore();
    const org = userData?.organization;
    const [loading, setLoading] = useState(true);
    const [tableConfig, setTableConfig] = useState(null);
    const [configColumns, setConfigColumns] = useState(null);
    const [loadingConfig, setLoadingConfig] = useState(true);

    console.log("mainData is '; ", mainData);

    const navigate = useNavigate();

    const getFormattedApiData = async (orgId) => {
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("No authentication token found");
            useAuthStore.getState().logout();
            navigate("/login", { replace: true });
            return [];
        }

        let retryCount = 0;
        const maxRetries = 1;

        while (retryCount <= maxRetries) {
            try {
                const params = {
                    per_page: "all",
                    organization_id: orgId,
                    mode: mode ?? 3,
                    ...(additionalParams || {})
                };

                const response = await axios.get(`${MAIN_URL}/${mainUrl}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                });

                const data = response.data.data;

                return data.map((item) => {
                    const itemId = item[mainKey] || item.id || item.organization_project_task_id;
                    
                    if (!itemId) {
                        console.warn("Item missing ID:", item, "mainKey:", mainKey);
                    }
                    
                    return {
                        ...item,
                        id: itemId,
                    };
                });
            } catch (err) {
                if (err.response?.status === 401) {
                    if (retryCount === 0) {
                        // Try token refresh (if endpoint exists)
                        retryCount++;
                        console.log("Token expired, attempting refresh...");
                        // Add refresh logic here if /api/auth/refresh exists
                        continue; // Retry once
                    } else {
                        toast.error("Session Expired!");
                        useAuthStore.getState().logout();
                        navigate("/login", { replace: true });
                        return [];
                    }
                }
                console.error("Failed to fetch data", err);
                return [];
            }
        }
        return [];
    };

    useEffect(() => {
        const loadTableConfiguration = async () => {
            if (!org?.organization_id) {
                setLoadingConfig(false);
                return;
            }

            try {
                const configRes = await fetch(
                    `${MAIN_URL}/api/general-datagrids`,
                    {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    }
                );

                if (configRes.ok) {
                    const configResponse = await configRes.json();
                    const datagrids = configResponse.datagrids || [];
                    const orgKey = `${gridKey}_${org.organization_id}`;
                    const savedConfig = datagrids.find(
                        (dg) => dg.datagrid_key === orgKey
                    );

                    if (savedConfig) {
                        const serverCfg = savedConfig.datagrid_default_configuration;
                        setTableConfig(serverCfg);

                        if (
                            serverCfg?.columns &&
                            Array.isArray(serverCfg.columns) &&
                            serverCfg.columns?.length > 0
                        ) {
                            setConfigColumns(serverCfg.columns);
                        } else {
                            setConfigColumns(null);
                        }
                    } else {
                        setConfigColumns(null);
                    }
                }
            } catch (error) {
                console.error("Error loading table configuration:", error);
                setConfigColumns(null);
            } finally {
                setLoadingConfig(false);
            }
        };

        loadTableConfiguration();
    }, [org?.organization_id]);

    useEffect(() => {
        if (org?.organization_id) {
            loadMainData();
        }
    }, [org, filterDependency, filterByReportingManagerEmployees ? (reporting_manager_employees || []).join(",") : "", filterByReportingManagerInterns ? (reporting_manager_interns || []).join(",") : ""]);

    const loadMainData = async () => {
        setLoading(true);
        const logs = await getFormattedApiData(org?.organization_id);
        // Apply filter if provided
        const filteredLogs = dataFilter ? logs.filter(dataFilter) : logs;
        setMainData(filteredLogs);
        setLoading(false);
    };

    let deleteFunction = async (id) => {
        try {
            await axios.delete(`${MAIN_URL}/${mainUrl}/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
        } catch (error) {
            console.error("Delete error:", error);
            throw error; // So Layout1 can catch and show toast
        }
    };

    return (
        <>
            <Layout4
                heading={heading}
                Route={route}
                btnName={btnName}
                showAddButton={true}
                add_action={add_action}
            />

            <TableDataGeneric
                copyFunction={copyFunction}
                copy_action={copy_action}
                viewFunction={viewFunction}
                infoFunction={infoFunction}
                info_action={info_action}
                gridKey={gridKey}
                tableName={heading}
                primaryKey="id"
                heading={heading}
                data={mainData}
                sortname={sortName}
                showActions={true}
                Route={route}
                DeleteFunc={deleteFunction}
                token={localStorage.getItem("token")}
                configss={configColumns}
                edit_delete_action={edit_delete_action}
                {...(tableConfig && { config: tableConfig })}
            />
        </>


    )
}

export default CommonList